(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["behuli-add-matching"] && !Shopify.designMode) return;
  try {
    (function () {
    function selectTab(tab, moveFocus) {
      var root = tab.closest('[data-bh-upsell]');
      if (!root) return;
      root.querySelectorAll('[data-bh-tab]').forEach(function (item) {
        var active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      root.querySelectorAll('[data-bh-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.bhPanel !== tab.dataset.bhTab;
      });
      if (moveFocus) tab.focus();
    }

    function addAccessory(button) {
      if (button.disabled) return;
      var root = button.closest('[data-bh-upsell]');
      var status = root && root.querySelector('[data-bh-status]');
      var defaultLabel = button.dataset.labelDefault;
      button.disabled = true;
      button.textContent = button.dataset.labelAdding;
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) throw new Error();
          return response.json();
        })
        .then(function () {
          button.textContent = button.dataset.labelAdded;
          if (status) status.textContent = button.dataset.productTitle + ' ' + root.dataset.labelStatus;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {
          button.textContent = button.dataset.labelUnavailable;
        })
        .finally(function () {
          window.setTimeout(function () {
            button.disabled = false;
            button.textContent = defaultLabel;
          }, 2200);
        });
    }

    document.addEventListener('click', function (event) {
      var addButton = event.target.closest('[data-bh-add]');
      if (addButton) {
        event.preventDefault();
        addAccessory(addButton);
        return;
      }
      var tab = event.target.closest('[data-bh-tab]');
      if (tab) {
        event.preventDefault();
        selectTab(tab, false);
        return;
      }
      var previous = event.target.closest('[data-bh-prev]');
      var next = event.target.closest('[data-bh-next]');
      if (!previous && !next) return;
      var panel = event.target.closest('[data-bh-panel]');
      var rail = panel && panel.querySelector('[data-bh-rail]');
      if (!rail) return;
      var distance = rail.clientWidth;
      rail.scrollBy({ left: previous ? -distance : distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });

    document.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-bh-tab]');
      if (!tab) return;
      var root = tab.closest('[data-bh-upsell]');
      var tabs = Array.from(root.querySelectorAll('[data-bh-tab]'));
      var current = tabs.indexOf(tab);
      var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
      if (!step) return;
      event.preventDefault();
      selectTab(tabs[(current + step + tabs.length) % tabs.length], true);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["behuli-delivery-estimator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('behuli-delivery-estimator')) {
    customElements.define('behuli-delivery-estimator', class extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('[data-delivery-form]');
        const input = this.querySelector('[data-delivery-postcode]');
        const error = this.querySelector('[data-delivery-error]');
        const results = this.querySelector('[data-delivery-results]');
        const alteration = this.querySelector('[data-delivery-alteration]');

        alteration.addEventListener('change', () => {
          if (!results.hidden) form.requestSubmit();
        });

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const postcode = input.value.trim();
          if (!/^\d{4}$/.test(postcode)) {
            error.hidden = false;
            results.hidden = true;
            input.focus();
            return;
          }

          const destination = this.getDestination(Number(postcode));
          if (!destination) {
            error.hidden = false;
            results.hidden = true;
            input.focus();
            return;
          }

          error.hidden = true;
          const standard = this.getStandardEstimate(destination, Number(postcode));
          const express = destination.state === 'NSW' ? [1, 2] : [1, 3];
          const dispatchDate = this.nextBusinessDay(new Date());
          const alterationDays = alteration.checked ? [1, 2] : [0, 0];
          const standardWithProcessing = [
            standard[0] + 1 + alterationDays[0],
            standard[1] + 1 + alterationDays[1]
          ];
          const expressWithAlteration = [
            express[0] + alterationDays[0],
            express[1] + alterationDays[1]
          ];

          this.querySelector('[data-standard-date]').textContent = this.formatRange(dispatchDate, standardWithProcessing);
          this.querySelector('[data-express-date]').textContent = this.formatRange(dispatchDate, expressWithAlteration);
          this.querySelector('[data-delivery-note]').textContent = `${destination.label}: Both services are scheduled for next-business-day dispatch. Standard includes a 1 business day buffer in case courier pickup occurs the following day. Express orders are prioritised.${alteration.checked ? ' Alteration time is included.' : ' Select the alteration option if required.'} Regional and remote addresses may take longer.`;
          results.hidden = false;
        });
      }

      getDestination(postcode) {
        if ((postcode >= 200 && postcode <= 299) || (postcode >= 2600 && postcode <= 2618) || (postcode >= 2900 && postcode <= 2920)) return { state: 'ACT', label: 'ACT' };
        if (postcode >= 800 && postcode <= 999) return { state: 'NT', label: 'Northern Territory' };
        if ((postcode >= 1000 && postcode <= 2599) || (postcode >= 2619 && postcode <= 2899) || (postcode >= 2921 && postcode <= 2999)) return { state: 'NSW', label: 'New South Wales' };
        if ((postcode >= 3000 && postcode <= 3999) || (postcode >= 8000 && postcode <= 8999)) return { state: 'VIC', label: 'Victoria' };
        if ((postcode >= 4000 && postcode <= 4999) || (postcode >= 9000 && postcode <= 9999)) return { state: 'QLD', label: 'Queensland' };
        if (postcode >= 5000 && postcode <= 5999) return { state: 'SA', label: 'South Australia' };
        if (postcode >= 6000 && postcode <= 6999) return { state: 'WA', label: 'Western Australia' };
        if (postcode >= 7000 && postcode <= 7999) return { state: 'TAS', label: 'Tasmania' };
        return null;
      }

      getStandardEstimate(destination, postcode) {
        if (['WA', 'NT', 'TAS'].includes(destination.state)) {
          return [3, 6];
        }
        if (destination.state === 'ACT') return [1, 3];
        if (destination.state === 'SA') return [3, 5];
        if (destination.state === 'VIC') {
          if (postcode >= 3000 && postcode <= 3207) return [1, 3];
          return [2, 4];
        }
        if (destination.state === 'QLD') {
          if (postcode >= 4000 && postcode <= 4275) return [1, 3];
          if (postcode >= 4870 && postcode <= 4899) return [4, 6];
          if (postcode >= 4810 && postcode <= 4820) return [3, 5];
          return [2, 5];
        }
        if (destination.state === 'NSW') {
          if ((postcode >= 2000 && postcode <= 2234) || (postcode >= 2555 && postcode <= 2574) || (postcode >= 2740 && postcode <= 2786)) return [1, 2];
          return [1, 3];
        }
        return [2, 5];
      }

      nextBusinessDay(date) {
        const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        do {
          result.setDate(result.getDate() + 1);
        } while (result.getDay() === 0 || result.getDay() === 6);
        return result;
      }

      addBusinessDays(date, days) {
        const result = new Date(date);
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
        }
        return result;
      }

      formatRange(dispatchDate, range) {
        const first = this.addBusinessDays(dispatchDate, range[0]);
        const last = this.addBusinessDays(dispatchDate, range[1]);
        const formatter = new Intl.DateTimeFormat('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
        return `${formatter.format(first)} – ${formatter.format(last)}`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
